export type OfferProductType =
  | 'CON'
  | 'DOC'
  | 'SRV'
  | 'GES'
  | 'INC'
  | 'AUD'
  | 'NOL'

export interface OfferProduct {
  product: string
  type: OfferProductType
  code: string
}

export const offerProductTypes: OfferProductType[] = [
  'CON',
  'DOC',
  'SRV',
  'GES',
  'INC',
  'AUD',
  'NOL',
]

export const offerScopes = ['C', 'E', 'H', 'I', 'P', 'Q', 'SS', 'U']

export const offerProductCatalog: OfferProduct[] = [
  { product: 'Adeguamento whistleblowing', type: 'DOC', code: 'WBL-ADE' },
  { product: 'Consulenza Modello 231', type: 'CON', code: 'M231-CON' },
  { product: 'Consulenza antiriciclaggio', type: 'CON', code: 'AML-CON' },
  { product: 'Due diligence antiriciclaggio', type: 'AUD', code: 'AML-DD' },
  { product: 'Codice etico aziendale', type: 'DOC', code: 'ETH-COD' },
  { product: 'Consulenza pratica AUA', type: 'CON', code: 'AUA-CON' },
  {
    product: 'Consulenza sistema di gestione ambientale',
    type: 'CON',
    code: 'SGA-CON',
  },
  { product: 'Elaborazione e invio MUD', type: 'SRV', code: 'MUD-INV' },
  {
    product: 'Rilievo fonometrico Ambientale',
    type: 'SRV',
    code: 'AMB-FON',
  },
  {
    product: 'Piano di autocontrollo HACCP',
    type: 'DOC',
    code: 'HACCP-PAC',
  },
  { product: 'Gestione annuale HACCP', type: 'GES', code: 'HACCP-GES' },
  {
    product: 'Incarico responsabile autocontrollo HACCP',
    type: 'INC',
    code: 'HACCP-INC',
  },
  {
    product: 'Analisi microbiologica su alimento',
    type: 'SRV',
    code: 'HACCP-ANA',
  },
  {
    product: 'Tampone di superficie alimentare',
    type: 'SRV',
    code: 'HACCP-TAM',
  },
  {
    product: 'Consulenza integrata antiriciclaggio e privacy',
    type: 'CON',
    code: 'AML-PRV-CON',
  },
  {
    product: 'Incarico integrato RSPP e privacy',
    type: 'INC',
    code: 'RSPP-PRV-INC',
  },
  {
    product: 'Gestione integrata sicurezza e privacy',
    type: 'GES',
    code: 'SIC-PRV-GES',
  },
  {
    product: 'Incarico integrato RSPP e DPO',
    type: 'INC',
    code: 'RSPP-DPO-INC',
  },
  { product: 'RSPP / HACCP', type: 'INC', code: 'RSPP-HACCP' },
  { product: 'Adeguamento privacy', type: 'DOC', code: 'PRV-ADE' },
  { product: 'Consulenza protezione dati', type: 'CON', code: 'PRV-CON' },
  {
    product: 'Consulenza videosorveglianza',
    type: 'CON',
    code: 'CCTV-CON',
  },
  {
    product: 'Cookie policy e informativa sito',
    type: 'DOC',
    code: 'COOKIE-DOC',
  },
  { product: 'Gestione annuale privacy', type: 'GES', code: 'PRV-GES' },
  {
    product: 'Gestione privacy studio legale',
    type: 'GES',
    code: 'PRV-LEG-GES',
  },
  { product: 'Incarico RPD/DPO', type: 'INC', code: 'DPO-INC' },
  {
    product: 'Consulenza per rating EcoVadis',
    type: 'CON',
    code: 'ECOV-CON',
  },
  { product: 'Consulenza qualità', type: 'CON', code: 'QLT-CON' },
  {
    product: 'Consulenza sistema ISO 9001:2015',
    type: 'CON',
    code: 'ISO9001-CON',
  },
  {
    product: 'Consulenza sistema ISO/IEC 27001',
    type: 'CON',
    code: 'ISO27001-CON',
  },
  { product: 'Gestione annuale qualità', type: 'GES', code: 'QLT-GES' },
  {
    product: 'Audit o sopralluogo sicurezza',
    type: 'AUD',
    code: 'SIC-AUD',
  },
  { product: 'DVR rischio MAPO', type: 'DOC', code: 'DVR-MAPO' },
  { product: 'DVR rumore', type: 'DOC', code: 'DVR-RUM' },
  { product: 'DVR vibrazioni', type: 'DOC', code: 'DVR-VIB' },
  {
    product: 'Piano operativo di sicurezza (POS)',
    type: 'DOC',
    code: 'POS-DOC',
  },
  { product: 'Planimetrie di emergenza', type: 'DOC', code: 'PLAN-EMG' },
  {
    product: 'Valutazione rischio lavoratrici in gravidanza',
    type: 'DOC',
    code: 'DVR-GRAV',
  },
  {
    product: 'Gestione annuale sicurezza sul lavoro',
    type: 'GES',
    code: 'SIC-GES',
  },
  { product: 'Incarico RSPP', type: 'INC', code: 'RSPP-INC' },
  {
    product: 'Campionamento personale rumore',
    type: 'SRV',
    code: 'RUM-CAMP',
  },
  { product: 'Controllo estintori', type: 'SRV', code: 'EST-CONT' },
  { product: 'Prova di evacuazione', type: 'SRV', code: 'EVAC-PROV' },
  {
    product: 'Valutazione campi elettromagnetici',
    type: 'DOC',
    code: 'CEM-VAL',
  },
  {
    product: 'Noleggio attrezzature o spazi',
    type: 'NOL',
    code: 'NOL-ATT',
  },
]

export const offerProductOptions = offerProductCatalog.map(({ product }) => ({
  value: product,
  label: product,
}))

export function getOfferProductMetadata(
  product: string,
): OfferProduct | undefined {
  return offerProductCatalog.find((item) => item.product === product)
}
